import { render, staticRenderFns } from "./ServiceProject.vue?vue&type=template&id=2763f118&"
import script from "./ServiceProject.vue?vue&type=script&lang=ts&"
export * from "./ServiceProject.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceProject.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports